import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import theme from '../theme';
import keycloak from '../keycloak';

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard' },
  { path: '/accounts', label: 'Accounts' },
  { path: '/payments', label: 'Payments' },
  { path: '/beneficiaries', label: 'Beneficiaries' },
  { path: '/standing-orders', label: 'Standing Orders' },
];

function NavItem({ to, label }) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        padding: '8px 16px',
        borderRadius: theme.radiusSm,
        textDecoration: 'none',
        fontSize: '14px',
        fontWeight: isActive ? 600 : 400,
        color: isActive ? theme.colors.primary : theme.colors.textLight,
        background: isActive ? theme.colors.bgAlt : 'transparent',
        transition: 'all 0.15s',
      })}
    >
      {label}
    </NavLink>
  );
}

export default function Layout({ children, profile }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    keycloak.logout({ redirectUri: window.location.origin });
  };

  return (
    <div style={{ minHeight: '100vh', background: theme.colors.bgAlt }}>
      {/* Header */}
      <header style={{
        background: theme.colors.primary,
        color: '#fff',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '56px',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '18px', fontWeight: 700, letterSpacing: '-0.5px' }}>CoreBank</span>
          <span style={{ fontSize: '12px', opacity: 0.7, marginLeft: '4px' }}>Business Banking</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span
            onClick={() => navigate('/profile')}
            style={{ fontSize: '13px', opacity: 0.9, cursor: 'pointer' }}
          >
            {profile?.customerName || profile?.username}
          </span>
          <button
            onClick={handleLogout}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              color: '#fff',
              padding: '6px 14px',
              borderRadius: theme.radiusSm,
              fontSize: '13px',
              cursor: 'pointer',
            }}
          >
            Sign out
          </button>
        </div>
      </header>

      {/* Nav */}
      <nav style={{
        background: theme.colors.bgCard,
        borderBottom: `1px solid ${theme.colors.border}`,
        padding: '8px 24px',
        display: 'flex',
        gap: '4px',
        overflowX: 'auto',
      }}>
        {NAV_ITEMS.map(item => (
          <NavItem key={item.path} to={item.path} label={item.label} />
        ))}
      </nav>

      {/* Content */}
      <main style={{
        maxWidth: '1080px',
        margin: '0 auto',
        padding: '24px',
      }}>
        {children}
      </main>
    </div>
  );
}
